module.exports = __webpack_public_path__ + "static/media/Chevron-bottom.9d6f5d95.svg";